export default "__VITE_ASSET__IHd5dYnF__"